/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.listCommunities'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  spaces: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Community>((() => community) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** List community metadata visible to the authenticated viewer. Public communities are discoverable; restricted, invite-only, and private communities are listed only for their owner or an approved member. Space membership and record authorization remain standard ATProto Spaces behavior. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Community = {
  $type?: 'us.edriffles.radlib.private.listCommunities#community'
  uri: string
  authorityDid: l.DidString
  ownerDid: l.DidString
  kind: 'community' | l.UnknownString
  visibility?:
    'public' | 'restricted' | 'invite-only' | 'private' | l.UnknownString
  name?: string
  description?: string
  createdAt: l.DatetimeString
}

export type { Community }

const community = /*#__PURE__*/ l.typedObject<Community>(
  $nsid,
  'community',
  /*#__PURE__*/ l.object({
    uri: /*#__PURE__*/ l.string(),
    authorityDid: /*#__PURE__*/ l.string({ format: 'did' }),
    ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
    kind: /*#__PURE__*/ l.string<{ knownValues: ['community'] }>(),
    visibility: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['public', 'restricted', 'invite-only', 'private']
      }>(),
    ),
    name: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { community }
